import { NavListItem, NavListSectionHeader } from "#root/components/nav-list";
import type { ReactNode } from "react";
import { Fragment } from "react";
import { MdAttachMoney, MdPublic, MdRemoveShoppingCart, MdSwapHoriz, MdTableChart } from "react-icons/md";
import { NavLink } from "react-router-dom";
import Layout from "../layout";

export default function (props: Parameters<typeof Layout>["0"]): ReactNode {
  return (
    <Layout
      {...props}
      referenceElements={
        <Fragment>
          <NavListSectionHeader>Reference Data Platform</NavListSectionHeader>
          <NavLink to="/admin/platform/reference/exchange">
            <NavListItem icon={MdSwapHoriz}>Exchanges</NavListItem>
          </NavLink>
          <NavLink to="/admin/platform/reference/holiday">
            <NavListItem icon={MdRemoveShoppingCart}>Holidays</NavListItem>
          </NavLink>
          <NavLink to="/admin/platform/reference/corporateAction">
            <NavListItem icon={MdTableChart}>Corporate Actions</NavListItem>
          </NavLink>
          <NavLink to="/admin/platform/reference/currency">
            <NavListItem icon={MdAttachMoney}>Currencies</NavListItem>
          </NavLink>
          <NavLink to="/admin/platform/reference/domicile">
            <NavListItem icon={MdPublic}>Domiciles</NavListItem>
          </NavLink>
        </Fragment>
      }
    />
  );
}
